var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"m-dot",class:{'m-dot-2':_vm.$store.state.cart.length == 2}},[_vm._v(" "+_vm._s(_vm.$store.state.cart)+" "),_c('span',{staticClass:"dot-animate animate",style:({'opacity': _vm.animate  ? 1 : 0})})])}
var staticRenderFns = []

export { render, staticRenderFns }